import ReactGA from 'react-ga4';
import { NOT_FOUND } from 'redux-first-router';
import { routeToPageMap } from './pages';
import { NotFoundPage } from '../../ui/views';

const defaultState = {
  page: null,
};

export default function pageReducer(state = defaultState, action) {
  if (action.type === NOT_FOUND) {
    return {
      page: {
        component: NotFoundPage,
      },
    };
  }
  const page = routeToPageMap[action.type];

  if (page) {
    // Track analytics.
    ReactGA.send({ hitType: 'pageview', page: `${page.path} + ${window.location.search}`});
    return {
      page,
    };
  }

  return state;
}



// WEBPACK FOOTER //
// ./application/store/pageReducer.js